module.exports = __webpack_public_path__ + "static/media/peter_hartz.6b163234.png";